module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"todayAt":"Today at","yesterdayAt":"Yesterday at","last":"Last","at":"at"},"es":{"todayAt":"Hoy a las","yesterdayAt":"Ayer a las","last":"El","at":"pasado"}}')
  delete Component.options._Ctor
}
